import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="top-bar">FREE SHIPPING WITHIN CONTINENTAL U.S.</div>

      <div className="header-main">
        <div className="container">
          <div className="header-left">
            <Link to="/" className="logo" onClick={toTop}>
              Cartnovabin
            </Link>
          </div>

          <nav className="header-nav" aria-label="Main navigation">
            <ul>
              <li>
                <Link to="/shop" onClick={toTop}>
                  NEW ARRIVALS
                </Link>
              </li>
              <li>
                <Link to="/about" onClick={toTop}>
                  ABOUT US
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={toTop}>
                  CONTACT US
                </Link>
              </li>
            </ul>
          </nav>

          <div
            className="header-actions"
            role="group"
            aria-label="Header actions"
          >
            <Link
              to="/cartpage"
              className="icon-btn cart"
              onClick={toTop}
              aria-label="Cart"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-shopping-bag icon--large"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M19.575 6.75H4.425C4.24045 6.75087 4.06254 6.81891 3.92451 6.94141C3.78648 7.06391 3.69778 7.23249 3.675 7.41562L2.34375 19.4156C2.33191 19.5202 2.34221 19.6261 2.37396 19.7264C2.40572 19.8267 2.45823 19.9192 2.52808 19.9979C2.59794 20.0766 2.68357 20.1397 2.77941 20.1831C2.87525 20.2266 2.97916 20.2494 3.08438 20.25H20.9156C21.0209 20.2494 21.1248 20.2266 21.2206 20.1831C21.3164 20.1397 21.4021 20.0766 21.4719 19.9979C21.5418 19.9192 21.5943 19.8267 21.626 19.7264C21.6578 19.6261 21.6681 19.5202 21.6563 19.4156L20.325 7.41562C20.3022 7.23249 20.2135 7.06391 20.0755 6.94141C19.9375 6.81891 19.7596 6.75087 19.575 6.75V6.75Z" />
                <path d="M8.25 6.75C8.25 5.75544 8.64509 4.80161 9.34835 4.09835C10.0516 3.39509 11.0054 3 12 3C12.9946 3 13.9484 3.39509 14.6517 4.09835C15.3549 4.80161 15.75 5.75544 15.75 6.75" />
              </svg>

              <span
                className="cart-count"
                aria-hidden={cartItems.length === 0 ? "true" : "false"}
              >
                {cartItems.length}
              </span>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
